/**
 * Serverzeit aus dem Date-Response-Header des Lead-POST.
 *
 * Hintergrund: eine falsch gestellte Gerätezeit lässt sich clientseitig nicht
 * erkennen. Der Lead-POST findet ohnehin statt, also nehmen wir dessen
 * Date-Header als Zeitquelle für die Anrufzeit-Berechnung.
 *
 * ACHTUNG CORS: `Date` gehört *nicht* zu den CORS-safelisted response headers.
 * Auf allen Verticals mit eigener Domain (verkaufe-deine-immobilie.net,
 * einfach-zur-solaranlage.de, …) ist der POST auf einfach-zum-angebot.de/api.php
 * cross-origin — der Header ist dort nur lesbar, wenn api.php
 *     Access-Control-Expose-Headers: Date
 * sendet. Ohne das greift automatisch die Client-Zeit als Fallback.
 */

// Differenz Serverzeit - Clientzeit in ms, null solange unbekannt.
let offsetMs = null;

/**
 * Liest den Date-Header einer fetch-Response und merkt sich den Offset.
 * Schluckt jeden Fehler — die Zeitquelle darf den Lead-Flow nie stören.
 *
 * @returns {boolean} true, wenn Serverzeit übernommen wurde
 */
export function captureFromResponse(resp) {
    try {
        const header = resp && resp.headers && resp.headers.get('Date');
        if (!header) return false;

        const serverMs = new Date(header).getTime();
        if (Number.isNaN(serverMs)) return false;

        offsetMs = serverMs - Date.now();
        return true;
    } catch (e) {
        console.warn('ServerTime: Date-Header nicht lesbar, nutze Client-Zeit', e);
        return false;
    }
}

/** true, wenn eine Serverzeit vorliegt (für Diagnose/Logging). */
export function hasServerTime() {
    return offsetMs !== null;
}

/**
 * Aktuelle Zeit — serverkorrigiert wenn möglich, sonst Client-Zeit.
 * @returns {Date}
 */
export function now() {
    return new Date(Date.now() + (offsetMs || 0));
}

/** Nur für Tests. */
export function __reset() {
    offsetMs = null;
}

export default { captureFromResponse, hasServerTime, now };
